import styled from "styled-components"

export default styled.div`
  position: relative;
  margin: 0.6em 0;

  .ais-HierarchicalMenu {
    text-align: left;
    .ais-HierarchicalMenu-item--selected {
      a {
        color : red;
      }
      li:not(.ais-HierarchicalMenu-item--selected) {
        a {
          color : blue;
        }
      }
    }
  }
  
  .ais-Pagination-list {
    display : flex;
    justify-content: space-evenly;
    list-style-type: none;

    li {
      a {
        text-decoration: none;
        color : black;
        background: #DFE6ED;
        width : 30px;
        height : 30px;
        display : flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
      }
    }

    .ais-Pagination-item--selected {
      font-weight: bold;
    }

    .ais-Pagination-item--disabled {
      color : black;
      background: #DFE6ED30;
      width : 30px;
      height : 30px;
      display : flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
    }
  }
`